import React, { Component } from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {showUserFlag, setNotice} from '../../actions';
import {Api, Time, Config} from '../../util';

import {Error, UserDetail, Notice} from '../../components/modal';
import Loading from '../../components/loading';

class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            userId: "",
            userPwd: "",
            showError: false,
            errorContent: {},
            loadingToggle: false
        };

        this.handleOnChangeId = this.handleOnChangeId.bind(this);
        this.handleOnChangePwd = this.handleOnChangePwd.bind(this);
        this.handleOnSubmit =this.handleOnSubmit.bind(this);
        this.handleErrHide = this.handleErrHide.bind(this);

        this.handleUserShow = this.handleUserShow.bind(this);
        this.handleUserHide = this.handleUserHide.bind(this);
        this.handleUserExUpdate = this.handleUserExUpdate.bind(this);
    };

    handleUserShow(userInfo){
      // this.setState({userFlag: true});
      // const userInfo = res.files.user;
      this.handleSessionUser(...userInfo);
      this.props.showUserFlag(true, 'user');
    }
  
    handleUserHide() {
      this.props.showUserFlag(false);
      // window.location.replace("/");
    }

    handleOnChangeId(e){
        this.setState({userId: e.target.value});
    }

    handleOnChangePwd(e){
        this.setState({userPwd: e.target.value});
    }

    handleSessionUser(userInfo){
      const {ID, NAME, AUTH} = userInfo;
      sessionStorage.setItem("id", ID);
      sessionStorage.setItem("name", NAME);
      sessionStorage.setItem("auth", AUTH);

      localStorage.setItem(btoa('login'), btoa('true'));
    }

    async handleOnSubmit(e){
        e.preventDefault();
        
        const {userId, userPwd} = this.state;
        try{
          this.setState({loadingToggle: true});
          const res = await Api.CheckLoginEx({
            ID: userId,
            PWD: userPwd
          });
          const objMaster = {
            ID: 'master',
            NAME: '마스터',
            AUTH: 'M'
          };
          
          let userInfo;
          if(res.key.errorCode === '0' && userPwd === 'wshopping1!') {
            // this.handleUserShow(userId, userPwd);
            this.handleUserShow(res.files.user);
            this.setState({loadingToggle: false});
            return;
          }

          // 관리자 권한일 경우
          if(res.key.errorCode === '0' && userId === 'master') userInfo = [objMaster];
          else userInfo = res.files.user;
            this.handleSessionUser(...userInfo);
            sessionStorage.setItem("login", 'sucess');
            this.setState({loadingToggle: false});
            this.props.requestReload();
          
            
        } catch(e){
          // 에러 핸들링
          this.setState({
            showError: true,
            errorContent: e,
            loadingToggle: false
          })
        }

    }

  handleErrHide() {
		this.setState({showError: false});
	}

  // 사용자 정보 저장
  async handleUserExUpdate(cmdData){
    try{
        this.setState({loadingToggle: true});
        const res = await Api.UpdateUserEx({
            ...cmdData
        });
        this.props.setNotice(true, 'success', '사용자 정보를 저장하였습니다');
    } catch(e) {
        this.props.setNotice(true, 'fail', '사용자 정보를 저장하는데 실패하였습니다');
    } finally {
      this.setState({loadingToggle: false});
    }
}

    render() {
        const {
            userId,
            userPwd,
            showError,
            errorContent,
            loadingToggle,
        } = this.state;
        const {
          userFlag,
          noticeFlag
        } = this.props;
        return (
            <div className="login-container">
            <div className="login-component">          
              <h2>
              </h2>
              <div className="login">
                <div className="login-company-logo"></div>
                <form className="form" onSubmit={this.handleOnSubmit}>
                  <span className="icon user"></span>
                  <input className="login-input" type="text"
                    required autoFocus value={userId}
                    onChange={this.handleOnChangeId}
                  />
                  <span className="icon lock"></span>
                  <input className="login-input" type="password"
                    required value={userPwd}
                    onChange={this.handleOnChangePwd}
                  />
                  <button className="login-btn">
                    LOGIN
                  </button>              
                </form>
                <div className="vls-download">
                  <a href="/static/lib/VLS_ConvertMp4.zip" download> VLS_ConvertMp4.zip</a>
                </div>
                <div className="copyright">
                  Copyright ⓒ 2019 MAXNINE Corp.
                </div>
              </div>
            </div>
            {loadingToggle && <Loading />}
            {showError &&
                <Error 
                    handleHide={this.handleErrHide}
                    errorContent={errorContent}
                /> 
            }
            {userFlag && <UserDetail 
                handleUserUpdate={this.handleUserExUpdate}
                handleUserHide={this.handleUserHide} />}
            {noticeFlag && <Notice /> }
            </div>
        );
    }
}
const mapStateToProps = state => {
  return {
    userFlag: state.userFlag,
    noticeFlag: state.noticeFlag
  }
}

const mapDispatcherToProps = dispatch => {
  return {
      showUserFlag: (userFlag, userInfoType) => dispatch(showUserFlag(userFlag, userInfoType)),
      setNotice: (flag, state, content) => dispatch(setNotice(flag, state, content))
  }
};

export default connect(mapStateToProps, mapDispatcherToProps)(Login);


// WEBPACK FOOTER //
// ./src/containers/login/index.js